import users from './_users.json';
import businesses from './businesses.json';

export default {
  _users: users,
  businesses: businesses,
};